import React from 'react';

interface Row {
  name: string;
  code: string;
  quantity: string;
  unitPrice: string;
  value: string;
}

// Mirrors the layout of the printed PDF (see PDFReceipt.tsx) so the preview
// shows the document the app actually produces.
const ROWS: Row[] = [
  {
    name: 'Złom stalowy mieszany',
    code: '17 04 05',
    quantity: '420 kg',
    unitPrice: '1,15 zł',
    value: '483,00 zł',
  },
  {
    name: 'Miedź kabel',
    code: '17 04 01',
    quantity: '12,5 kg',
    unitPrice: '28,00 zł',
    value: '350,00 zł',
  },
  {
    name: 'Aluminium profil',
    code: '17 04 02',
    quantity: '8 kg',
    unitPrice: '6,50 zł',
    value: '52,00 zł',
  },
];

const ReceiptPreview: React.FC = () => (
  <div
    role="img"
    aria-label="Podgląd kwitu skupu: formularz przyjęcia odpadów metali z trzema pozycjami i kwotą do wypłaty 885,00 zł, zapisany w trybie offline."
    className="relative"
  >
    <div className="rounded-xl border border-gray-200 bg-white p-5 pb-12 shadow-xl shadow-gray-900/5 sm:p-7 sm:pb-14">
      <div className="border-b border-gray-200 pb-3 text-center">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-gray-500">
          Formularz przyjęcia odpadów metali
        </p>
        <p className="mt-1 text-sm font-bold text-gray-900">
          KWIT NR: 03/15/03/2026
        </p>
      </div>

      <dl className="mt-3 space-y-1 text-xs">
        <div className="flex gap-2">
          <dt className="font-semibold text-gray-500">SPRZEDAJĄCY:</dt>
          <dd className="text-gray-900">Jan Kowalski</dd>
        </div>
        <div className="flex gap-2">
          <dt className="font-semibold text-gray-500">ADRES:</dt>
          <dd className="text-gray-900">ul. Polna 12, 42-200 Częstochowa</dd>
        </div>
      </dl>

      <table className="mt-4 w-full border-collapse text-xs">
        <thead>
          <tr className="border-y border-gray-200 bg-gray-50 text-left text-gray-500">
            <th scope="col" className="py-1.5 pr-2 font-semibold">
              Rodzaj towaru
            </th>
            <th
              scope="col"
              className="hidden py-1.5 pr-2 font-semibold sm:table-cell"
            >
              Kod odpadu
            </th>
            <th scope="col" className="py-1.5 pr-2 text-right font-semibold">
              Ilość
            </th>
            <th scope="col" className="py-1.5 pr-2 text-right font-semibold">
              Cena jedn.
            </th>
            <th scope="col" className="py-1.5 text-right font-semibold">
              Wartość
            </th>
          </tr>
        </thead>
        <tbody className="text-gray-900">
          {ROWS.map(row => (
            <tr key={row.name} className="border-b border-gray-100">
              <td className="py-2 pr-2">{row.name}</td>
              <td className="hidden py-2 pr-2 tabular-nums text-gray-500 sm:table-cell">
                {row.code}
              </td>
              <td className="py-2 pr-2 text-right tabular-nums">
                {row.quantity}
              </td>
              <td className="py-2 pr-2 text-right tabular-nums">
                {row.unitPrice}
              </td>
              <td className="py-2 text-right tabular-nums">{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-4 flex items-baseline justify-between rounded-lg bg-orange-50 px-3 py-2.5">
        <span className="text-[11px] font-bold uppercase tracking-wider text-orange-900">
          Do wypłaty
        </span>
        <span className="text-lg font-bold tabular-nums text-orange-900">
          885,00 zł
        </span>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-6">
        {['Sprzedający', 'Kupujący'].map(label => (
          <div key={label}>
            <div className="border-t border-dashed border-gray-300" />
            <p className="mt-1 text-center text-[10px] uppercase tracking-wider text-gray-400">
              {label}
            </p>
          </div>
        ))}
      </div>
    </div>

    <div className="absolute -bottom-4 left-4 right-4 flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 shadow-lg shadow-gray-900/5 sm:-bottom-5 sm:left-auto sm:-right-6 sm:w-64">
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75 motion-safe:animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-500" />
      </span>
      <p className="text-xs text-gray-600">
        Zapisano offline —{' '}
        <span className="text-gray-400">zsynchronizuje się samo</span>
      </p>
    </div>
  </div>
);

export default ReceiptPreview;
